export default "__VITE_ASSET__Cn5sxrvD__"